"use client";

import * as React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  author: "Robert M.",
  quote: "Caravan Smash Repairs handled my insurance claim seamlessly. The hail damage is completely gone, and it looks brand new!",
  position: "Sydney Caravan Owner",
  rating: 5
}, {
  author: "Linda K.",
  quote: "Expert electrical work on our off-grid setup. Their attention to detail in the wiring was impressive. Highly professional team.",
  position: "Adventure Traveller",
  rating: 5
}, {
  author: "David P.",
  quote: "From structural repairs to a new AC install, these guys are the best in South Windsor. Quick, reliable, and top-quality finish.",
  position: "Local Resident",
  rating: 5
}];
export default function HomeownerSuccessStories() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="38775" id="voices-of-happy-travellers" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div ref={ref} className={cn("transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-extrabold tracking-tighter uppercase mb-4 font-sans">
              Voices of Happy Travellers
            </h2>
            <div className="h-1.5 w-24 bg-accent mx-auto rounded-sm" />
          </div>

          <div className="max-w-4xl mx-auto relative">
            <Carousel opts={{
            align: "start",
            loop: true
          }} className="w-full">
              <CarouselContent>
                {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="md:basis-full lg:basis-full">
                    <div className="flex flex-col items-center text-center px-4 md:px-12 py-8 relative">
                      {}
                      <Quote className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-4 w-32 h-32 text-secondary/10 rotate-180 pointer-events-none" strokeWidth={1} />

                      {}
                      <div className="flex gap-1 mb-6 relative z-10">
                        {Array.from({
                      length: testimonial.rating
                    }).map((_, starIndex) => <Star key={starIndex} className="w-5 h-5 fill-accent text-accent" />)}
                      </div>

                      {}
                      <blockquote className="text-xl md:text-3xl font-medium leading-relaxed mb-8 relative z-10 max-w-2xl font-sans italic">
                        &quot;{testimonial.quote}&quot;
                      </blockquote>

                      {}
                      <div className="relative z-10">
                        <cite className="not-italic font-bold text-xl block text-foreground uppercase tracking-tight font-sans">
                          {testimonial.author}
                        </cite>
                        <span className="text-secondary text-xs font-mono uppercase tracking-widest mt-1 block">
                          {testimonial.position}
                        </span>
                      </div>
                    </div>
                  </CarouselItem>)}
              </CarouselContent>

              {}
              <div className="hidden md:block">
                <CarouselPrevious className="h-12 w-12 border border-border bg-secondary/10 text-foreground hover:bg-accent hover:text-accent-foreground hover:border-accent shadow-lg transition-all duration-300 -left-16" />
                <CarouselNext className="h-12 w-12 border border-border bg-secondary/10 text-foreground hover:bg-accent hover:text-accent-foreground hover:border-accent shadow-lg transition-all duration-300 -right-16" />
              </div>
              
              {}
              <div className="flex md:hidden justify-center gap-4 mt-8">
                 <CarouselPrevious className="static translate-y-0 h-12 w-12 border border-border bg-secondary/10 text-foreground hover:bg-accent hover:text-accent-foreground hover:border-accent shadow-lg transition-all duration-300" />
                <CarouselNext className="static translate-y-0 h-12 w-12 border border-border bg-secondary/10 text-foreground hover:bg-accent hover:text-accent-foreground hover:border-accent shadow-lg transition-all duration-300" />
              </div>
            </Carousel>
          </div>
        </div>
      </div>
    </section>;
}